/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { FieldFragmentDoc } from '../../ui-legacy/Field/Field.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type Filter_BooleanField_Fragment = {
  __typename: 'BooleanField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  state?: boolean | null
  localEdited?: boolean | null
  localState?: boolean | null
}

export type Filter_DateField_Fragment = {
  __typename: 'DateField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  date?: any | null
  localEdited?: boolean | null
  localDate?: string | null
}

export type Filter_DateTimeField_Fragment = {
  __typename: 'DateTimeField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  dateTime?: any | null
  localEdited?: boolean | null
  localDateTime?: string | null
}

export type Filter_DownloadFileField_Fragment = {
  __typename: 'DownloadFileField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  selection?: {
    __typename?: 'SelectField'
    style?: Types.SelectStyle | null
    localEdited?: boolean | null
    id: string
    label?: string | null
    description?: string | null
    information?: string | null
    options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
    selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
    localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
  } | null
}

export type Filter_MultiSelectField_Fragment = {
  __typename: 'MultiSelectField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  style?: Types.SelectStyle | null
  localEdited?: boolean | null
  options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
  selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
  localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
}

export type Filter_NumberField_Fragment = {
  __typename: 'NumberField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  value?: number | null
  localEdited?: boolean | null
  localValue?: number | null
}

export type Filter_NumberRangeField_Fragment = {
  __typename: 'NumberRangeField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
}

export type Filter_SelectField_Fragment = {
  __typename: 'SelectField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  style?: Types.SelectStyle | null
  localEdited?: boolean | null
  options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
  selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
  localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
}

export type Filter_TextField_Fragment = {
  __typename: 'TextField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  text?: string | null
  localEdited?: boolean | null
  localText?: string | null
}

export type Filter_UploadFileField_Fragment = {
  __typename: 'UploadFileField'
  id: string
  label?: string | null
  description?: string | null
  information?: string | null
  overrideAppId?: string | null
  templateId?: string | null
  entityId?: string | null
}

export type FilterFragment =
  | Filter_BooleanField_Fragment
  | Filter_DateField_Fragment
  | Filter_DateTimeField_Fragment
  | Filter_DownloadFileField_Fragment
  | Filter_MultiSelectField_Fragment
  | Filter_NumberField_Fragment
  | Filter_NumberRangeField_Fragment
  | Filter_SelectField_Fragment
  | Filter_TextField_Fragment
  | Filter_UploadFileField_Fragment

export type FilterQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  filterId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filters: Array<Types.FieldInput> | Types.FieldInput
}>

export type FilterQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    id: string
    filterById?:
      | {
          __typename: 'BooleanField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          state?: boolean | null
          localEdited?: boolean | null
          localState?: boolean | null
        }
      | {
          __typename: 'DateField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          date?: any | null
          localEdited?: boolean | null
          localDate?: string | null
        }
      | {
          __typename: 'DateTimeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          dateTime?: any | null
          localEdited?: boolean | null
          localDateTime?: string | null
        }
      | {
          __typename: 'DownloadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          selection?: {
            __typename?: 'SelectField'
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          } | null
        }
      | {
          __typename: 'MultiSelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        }
      | {
          __typename: 'NumberField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          value?: number | null
          localEdited?: boolean | null
          localValue?: number | null
        }
      | {
          __typename: 'NumberRangeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
        }
      | {
          __typename: 'SelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        }
      | {
          __typename: 'TextField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          text?: string | null
          localEdited?: boolean | null
          localText?: string | null
        }
      | {
          __typename: 'UploadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          overrideAppId?: string | null
          templateId?: string | null
          entityId?: string | null
        }
      | null
  } | null
}

export const FilterFragmentDoc = gql`
  fragment Filter on Field {
    ...Field
  }
  ${FieldFragmentDoc}
`
export const FilterDocument = gql`
  query Filter($appId: ID!, $filterId: ID!, $projectId: Int, $filters: [FieldInput!]!) {
    app(id: $appId, projectId: $projectId, filters: $filters) {
      id
      filterById(id: $filterId) {
        ...Filter
      }
    }
  }
  ${FilterFragmentDoc}
`

/**
 * __useFilterQuery__
 *
 * To run a query within a React component, call `useFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      filterId: // value for 'filterId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterQuery(baseOptions: Apollo.QueryHookOptions<FilterQuery, FilterQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options)
}
export function useFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterQuery, FilterQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FilterQuery, FilterQueryVariables>(FilterDocument, options)
}
export type FilterQueryHookResult = ReturnType<typeof useFilterQuery>
export type FilterLazyQueryHookResult = ReturnType<typeof useFilterLazyQuery>
export type FilterQueryResult = Apollo.QueryResult<FilterQuery, FilterQueryVariables>
